// extracted by mini-css-extract-plugin
export default {"aiNoteButton":"AINoteButton__aiNoteButton--1gpGf","aiNoteButtonContent":"AINoteButton__aiNoteButtonContent--9FxyP","text":"AINoteButton__text--1lPb9"};